module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Изменения в ЕГРЮЛ (" + _vm._s(_vm.items.length) + ")\n      "), _vm._l((_vm.topItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.updated, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(item.value) + "\n        ")])]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.updated, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(item.value) + "\n      ")])]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb132f0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/RecordsPanel.vue
// module id = 1074
// module chunks = 1